import { Component, OnInit, Inject, TemplateRef, HostListener } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from '../services/admin.service';
import { Storage } from 'aws-amplify';
import { ConstantsService } from '../services/constants.service';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { DatePipe } from '@angular/common';
import { SpinnerService } from '../services/spinner.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { NgbAlertModule, NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-my-window-edit',
  templateUrl: './my-window-edit.component.html',
  styleUrls: ['./my-window-edit.component.scss']
})
export class MyWindowEditComponent implements OnInit {
  // model: NgbDateStruct;
  maxDate
  public urlPrefix = environment.S3_URL_PRFIX;
  public id = "";
  public currentVideoStatus;
  public currentVideoName;
  public isRemoving = false;
  public showDeleteBox = false;
  public deleteItem: any;
  public nicknameValidationError: boolean = false;
  public locationValidationError: boolean = false;
  nickName: any;
  form: UntypedFormGroup;
  dateRecording: any;
  animalActive: boolean = false;
  rainActive: boolean = false;
  snowActive: boolean = false;
  cityActive: boolean = false;
  public queueArray = [];
  natureActive: boolean = false;
  nightActive: boolean = false;
  dayActive: boolean = false;
  interiorActive: boolean = false;
  isLoading: boolean = false
  waterActive: boolean = false;
  screenHeight: number;
  screenWidth: number;
  windowWidth: string;
  loader = true
  formattedDate;
  yourDateObject
  isEmptyWindow: boolean;
  campaignId: any;
  videoIdData: any;
  currentUser: any;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 576 && this.screenWidth < this.screenHeight) {
      this.windowWidth = `${this.screenHeight}px`;
    }
  }
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private adminservice: AdminService,
    public constants: ConstantsService,
    private dataService: DataService,
    private spinner: SpinnerService,
    private datePipe: DatePipe,
    private urlConstants: UrlConstants,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<MyWindowEditComponent>) { }

  ngOnInit(): void {
    document.getElementById("confirm").style.display = "none"
    this.onResize();
    this.currentUser = this.data.emailId;
    const today = new Date().toISOString().split('T')[0];
    this.maxDate = today;
    this.initializeForm()
    setTimeout(() => {
      this.loader = false; // Hide the loader after 10 seconds
    }, 10000);
  }

  initializeForm() {
    const timestamp = this.data.dateRecording;
    this.yourDateObject = new Date(timestamp * 1000);

    // Format the date as dd/MM/yyyy
    const day = this.yourDateObject.getDate().toString().padStart(2, '0');
    const month = (this.yourDateObject.getMonth() + 1).toString().padStart(2, '0');
    const year = this.yourDateObject.getFullYear();
    this.formattedDate = `${year}-${month}-${day}`;
    this.animalActive = this.data.tag.Animals;
    this.rainActive = this.data.tag.Rain;
    this.snowActive = this.data.tag.Snow;
    this.cityActive = this.data.tag.City
    this.natureActive = this.data.tag.Nature;
    this.nightActive = this.data.tag.Night;
    this.dayActive = this.data.tag.Day;
    this.interiorActive = this.data.tag.Interior;
    this.waterActive = this.data.tag.Water
    this.nickName = this.data.nickName
    this.form = this.fb.group({
      nickName: [this.nickName, [Validators.maxLength(25)]],
      location: [this.data.cityLocation, Validators.maxLength(25)],
      country: [this.data.country],
      timeRecording: [this.data.timeRecording],
      dateRecording: [this.formattedDate],
    });
  }


  onChangeTag(value) {
    if (value === 'Animals') {
      this.animalActive = !this.animalActive;
    }
    else if (value === 'City') {
      this.cityActive = !this.cityActive;
    }
    else if (value === 'DayVideo') {
      this.dayActive = !this.dayActive;
    }
    else if (value === 'Interiors') {
      this.interiorActive = !this.interiorActive;
    }
    else if (value === 'Water') {
      this.waterActive = !this.waterActive;
    }
    else if (value === 'Nature') {
      this.natureActive = !this.natureActive;
    }
    else if (value === 'Night') {
      this.nightActive = !this.nightActive;
    }
    else if (value === 'Rain') {
      this.rainActive = !this.rainActive;
    }
    else if (value === 'Snow') {
      this.snowActive = !this.snowActive;
    }

  }

  onSubmit(event: Event) {
    if (this.form.get('nickName').value?.trim() === '' || !this.form.get('nickName').value) {
      this.nicknameValidationError = true;
      return;
    }
    if (this.form.get('location').value?.trim() === '' || !this.form.get('location').value) {
      this.locationValidationError = true;
      return;
    }
    this.nicknameValidationError = false;
    this.locationValidationError = false;
    this.isLoading = true
    const dateStr = this.form.value.dateRecording;
    const convertedDate = Date.parse(dateStr) / 1000;

    const tags = {
      Animals: this.animalActive,
      Rain: this.rainActive,
      Snow: this.snowActive,
      City: this.cityActive,
      Nature: this.natureActive,
      Night: this.nightActive,
      Day: this.dayActive,
      Interior: this.interiorActive,
      Water: this.waterActive,
    };
    this.form.get('dateRecording').setValue(convertedDate);
    // this.form.get('tag').setValue(tags);
    const updatedTitle = `${this.form.value.nickName.trim()} - ${this.form.value.location.trim()}, ${this.form.value.country}`;
    let attributes = [{
      videoName: this.data.videoName,
      commonKey: this.constants.VIDEO_COMMON_KEY,
      updatedNickname: this.form.value.nickName.trim(),
      updatedLocation: this.form.value.location.trim(),
      updatedCountry: this.form.value.country,
      updatedTimeRecording: this.form.value.timeRecording,
      updatedDateRecording: this.form.value.dateRecording,
      updatedTitle: updatedTitle,
      otherStatus: "nameUpdate",
      tags: tags
    }];

    this.adminservice.EditName(attributes)
      .then(data => {
        this.isLoading = false
        this.dialogRef.close(attributes);
        document.getElementById("confirm").style.display = "block";
      })
  }

  onClickClosePopup() {
    this.dialogRef.close();
  }

  onClickShowConfirmPopup(item, event) {
    this.id = item.videoName;
    this.currentVideoStatus = item.videoStatus;
    this.currentVideoName = item.videoName;
    document.getElementById("modal-popup-confirm").style.display = "flex"
  }
  onClickCloseConfirmPopup() {
    document.getElementById("modal-popup-confirm").style.display = "none"
  }
  async onClickRemove() {
    //  document.getElementById(this.id).style.opacity = "50%"
    const id = this.deleteItem.videoName;
    const currentVideoStatus = this.deleteItem.videoStatus;
    const currentVideoName = this.deleteItem.videoName;
    this.isRemoving = true
    const params = [
      { param: '{object}', value: "submit" },
    ];
    const bodyObj = {
      "commonKey": this.constants.VIDEO_COMMON_KEY,
      "videoName": id,
      "vimeoToken": this.deleteItem.vimeoToken,
      "videoUrl": this.deleteItem.videoUrl
    }
    this.dataService.postData(this.urlConstants.getUri(this.urlConstants.deleteItem, params), JSON.stringify(bodyObj)).subscribe({
      next: async (data: any) => {
        //   document.getElementById(this.id).style.display = "none"
        // await this.myvideos();
        this.isRemoving = false;
        this.dialogRef.close(this.currentUser);
        // this.dialog.closeAll();
        document.getElementById("confirm").style.display = "block"
        // this.isRemoving = false;
        setTimeout(function () {
          document.getElementById("confirm").style.display = "none"
        }, 7000);
      },
      error: (err) => {
        console.error('Error deleting video:', err);
        this.isRemoving = false
      }
    })
  }

  async myvideos() {
    const params = [
      { param: '{object}', value: "getUserVideos" },
      { param: '{id1}', value: this.currentUser },
      { param: '{id2}', value: 'GetVideoList' },
    ];
    let videoList;
    await this.dataService.getData(this.urlConstants.getUri(this.urlConstants.getList, params)).subscribe(async data => {
      if (data !== undefined) {

        if (data['Items']['pendingVideo'] !== undefined) {
          this.queueArray = data['Items']['pendingVideo'];

        }

        this.isLoading = false
      }
      else {
        this.isEmptyWindow = true;
        this.isLoading = false;
      }
    }, err => {
      this.isEmptyWindow = true;
      this.isLoading = false;
    });
  }
  openDialog(item) {
    this.deleteItem = item;
    // document.getElementById("delete-modal-popup-confirm").style.display = "flex"
    this.showDeleteBox = true;
    //this.id = item.videoName;
    this.videoIdData = item.videoId;
    this.campaignId = item.campaignId
    // this.currentVideoName = item.videoName;
  }
  closeDialog() {
    this.showDeleteBox = false;
    this.deleteItem = null;
    // document.getElementById("delete-modal-popup-confirm").style.display = "none"

  }
  async onDelete() {
    this.isRemoving = true
    const params = [{ param: '{object}', value: 'videos' }];
    const bodyObj = {
      campaignId: this.campaignId,
      videoId: this.videoIdData,
    };


  }
}